<template>
    <div class="docs-list" id="section-6" style="display: none">
        <h1>Configuration Tool</h1>

        <hr/>

        <pre><code>Configuration tool is a mobile App built for checking and modifying Yunzi’s parameters. iPhone and Android versions are available to download.
</code></pre>

        <h3>I. Device list</h3>

        <p>Open up the configuration tool, you will see all the Yunzi Beacons nearby. Each Yunzi's Major, Minor and
            animated RSSI bar will be shown on the list. As to devices with firmware version 3.x, the list will also
            indicate the transmitter power and advertising interval.</p>

        <p><strong>Shown as following：</strong></p>

        <p style="text-align:center">
            <img src="/static/image/developer/config/1.png" height="480" width="270" alt=""/>
        </p>

        <p>You may search for Yunzi according to SN, UMM, model, firmware version, etc, or scan the attached QR code to
            access to designated Yunzi conveniently.</p>

        <h3>II. Device detail page</h3>

        <ol>
            <li>
                <p>Click listed device to enter its detail page. Every Yunzi is integrated with a temperature sensor, a
                    light sensor and an accelerometer. All the sensors’ data will be real-time displayed on this page,
                    which reflects the operation status of specific Yunzi in a visualized and direct manner.
                </p>
                <p style="text-align:center">
                    <img src="/static/image/developer/config/2.png" height="480" width="270" alt=""/>
                </p>
            </li>
            <li>
                <p>A real-time RSSI line chart is provided, which helps developers to check Yunzi’s signal fluctuation
                    precisely. Please refer to the following figure：</p>

                <p style="text-align:center">
                    <img src="/static/image/developer/config/3.png" height="480" width="270" alt=""/>
                </p>
            </li>
        </ol>


        <h3>III. Settings</h3>

        <p>Yunzi, serving as an iBeacon smart sensor, is capable to provide five main configurable functions. You will
            have access to the settings in this configuration tool:</p>

        <ol>
            <li>
                <p>iBeacon</p>

                <p> iBeacon is a standard function introduced by Apply, which complies to iBeacon protocol standardized
                    by Apple. This configuration tool provides switch of iBeacon function and edit function of UUID,
                    Major and Minor.</p>
            </li>
            <li>
                <p>Broadcasting</p>

                <p> Yens is capable to broadcast data packet on predesigned transmitter power and broadcasting
                    intervals. The broadcasting content is determined by the on/off status of each function, including
                    the status of iBeacon function and sensors. Configurations of transmitter power and broadcasting
                    intervals are provided in this section. With larger transmitter power, more signal coverage area
                    will be enabled and vice versa. The device becomes more recognizable if the broadcasting interval is
                    shorter and meanwhile the data refreshes more frequently as well. However, it demands higher energy
                    consumption with larger transmitter power and more frequent broadcasting, for instance,
                    100ms/+8dBm.
                </p>
            </li>
            <li>
                <p>Sensors</p>

                <p> In addition to standard iBeacon function, Yunzi has integrated multiple sensors including
                    temperature sensor, light sensor, accelerometer, etc. The app has included switches of each sensor
                    and can reset the move(accelerometer) counter to zero.
                </p>
            </li>
            <li>
                <p>Prevent Squatters</p>

                <p> Yunzi complies with iBeacon standard protocol released by Apple. However, this standard protocol has
                    some minor problems. For example, with the accomplishment of the deployment, other developer may
                    also have access to the device without the deployer’s authorization. Besides, iBeacon protocol has
                    relatively weak resistance to attacks. For instance, if there is a system consisted of 100 devices,
                    an underminer may destroy the system by copying some of the devices and installing them into the
                    deployment circumstance.
                    To resolve this problematic situation, you may adopt Sensoro proprietary protocol by setting up a
                    key (firmware version 3.x or above required). Please be noted that there are a limited number of
                    keys provided. You may <code>apply</code> on SENSORO Cloud.
                </p>
            </li>
            <li>
                <p>Prevent tampering</p>

                <p> Each Yunzi can be assigned with one unique password. After the password setup, the password will be
                    required to get access to Yunzi’s configuration.
                    <strong>Please note that the password if irretrievable and should be kept firmly. </strong>
                </p>
            </li>
        </ol>


        <p style="text-align:center"><img src="/static/image/developer/config/4.jpg" height="862" width="270" alt=""/>
        </p>
        <div class="download-app first">
            <a class="ios-download"
               href="https://itunes.apple.com/cn/app/sensoro-yun-zi-pei-zhi/id902437077?mt=8"
               style="margin-right:20px;">iOS Configuration Tool</a>
            <a href="https://play.google.com/store/apps/details?id=com.sensoro.beaconconfig">Android
                Configuration Tool</a>
        </div>
        <div class="download-app">
            <span style="display: block; margin-bottom: 10px;">Download more Apps</span>
            <img id="qrcode" src="/static/image/docs/qrcode.png" width="115px"/>
        </div>

    </div>
</template>

<script>
    export default {
        name: "config"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/docs/config.vue